import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { NavLink, Link } from 'react-router-dom';
import { withRouter } from 'react-router';

import { logoutUser,
  showPasswordChangeModal,
  hidePasswordChangeModal,
  userPasswordChange,
  getCicAlertCounts,
  openAboutModal
} from 'actions';

import { AuthMode } from 'actions/auth/common';

import blanks from 'components/Blanks/blanks.json';
import AccessControl from 'components/AccessControl';
import ActivityPerms from 'components/AccessControl/permissions.json';
import PasswordChangeModal from 'components/Modals/PasswordChangeModal';
import withContainerErrorBoundary from 'components/ErrorBoundaries/ContainerErrorBoundary/withContainerErrorBoundary';
import PoweredBy from 'components/PoweredBy';
import AboutModal from 'components/Modals/AboutModal';

class Header extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    location: PropTypes.shape().isRequired,
    username: PropTypes.string.isRequired,
    settings: PropTypes.shape(),
    sessionAuthMode: PropTypes.string,
    permissions: PropTypes.arrayOf(PropTypes.string),
    isPasswordChangeModalShown: PropTypes.bool,
    cicAlertsUnassignedCount: PropTypes.number,
    cicAlertsAssignedCount: PropTypes.number,
    isAboutOpen: PropTypes.bool
  };

  static defaultProps = {
    settings: null,
    permissions: null,
    sessionAuthMode: AuthMode.Manual,
    isPasswordChangeModalShown: false,
    cicAlertsUnassignedCount: 0,
    cicAlertsAssignedCount: 0,
    isAboutOpen: false
  };

  constructor(props) {
    super(props);

    this.state = {
      moduleMenuShown: false,
      bellPopupShown: false,
      includeUnassigned: true
    };
  }

  /* eslint-disable-next-line camelcase */
  UNSAFE_componentWillMount() {
    document.addEventListener('click', this.handleClickOutside, true);
    document.addEventListener('click', this.handleClickOutsideBellPopup, true);
    this.getCicAlertCounts();
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, true);
    document.removeEventListener('click', this.handleClickOutsideBellPopup, true);
  }

  get changePasswordText() {
    const { sessionAuthMode } = this.props;
    return (sessionAuthMode !== AuthMode.SSO) ? 'Change Password' : null;
  }

  setIncludeAssigned(includeUnassigned) {
    this.setState({ includeUnassigned });
  }

  getBellClassName() {
    const { cicAlertsUnassignedCount, cicAlertsAssignedCount } = this.props;
    const { includeUnassigned } = this.state;
    if ((!includeUnassigned || cicAlertsUnassignedCount === 0) && cicAlertsAssignedCount === 0) return 'standard';
    return 'red';
  }

  getCicAlertCounts() {
    const { settings, permissions, dispatch } = this.props;

    const modulesLicenced = settings && (settings.showBatches || settings.showOngoingMonitoring || settings.showDigitalEntry);

    if (modulesLicenced && (AccessControl.hasPermission(permissions, [ActivityPerms.monitoringExpertReviewer, ActivityPerms.monitoringResolver], true))) {
      dispatch(getCicAlertCounts());
    }
  }

  handleClickOutside = (event) => {
    const { moduleMenuShown } = this.state;
    if (moduleMenuShown && (!this.moduleMenu || !this.moduleMenu.contains(event.target))) {
      this.toggleMenu();
    }
  };

  handleClickOutsideBellPopup = (event) => {
    const { bellPopupShown } = this.state;
    if (bellPopupShown && (!this.bellpopup || !this.bellpopup.contains(event.target))) {
      this.toggleBellPopup();
    }
  };

  logout() {
    const { dispatch, settings, sessionAuthMode } = this.props;
    const switchClient = sessionAuthMode === AuthMode.SSO && settings && settings.clients && settings.clients.length !== 1;
    dispatch(logoutUser(switchClient, sessionAuthMode === AuthMode.SSO));
    localStorage.setItem('taina.logout', Date.now());
  }

  openPasswordChangeModal() {
    const { dispatch, sessionAuthMode } = this.props;

    if (sessionAuthMode === AuthMode.SSO) {
      // Don't allow user to change password when logged in via SSO
      return;
    }

    dispatch(showPasswordChangeModal());
  }

  closePasswordChangeModal() {
    const { dispatch } = this.props;
    dispatch(hidePasswordChangeModal());
  }

  processPasswordChangeModal(updateData) {
    const { dispatch, username } = this.props;
    dispatch(userPasswordChange(username, updateData));
  }

  toggleMenu() {
    const { moduleMenuShown } = this.state;
    this.setState({ moduleMenuShown: !moduleMenuShown });
  }

  toggleBellPopup() {
    const { bellPopupShown } = this.state;
    this.setState({ bellPopupShown: !bellPopupShown });
  }

  showModuleMenu() {
    const { settings, permissions } = this.props;

    const modulesLicenced = settings && (settings.showBatches || settings.showOngoingMonitoring || settings.showDigitalEntry || settings.showMultiTierManager);

    return modulesLicenced && (AccessControl.hasPermission(permissions, [
      ActivityPerms.monitoringExpertReviewer,
      ActivityPerms.monitoringResolver,
      ActivityPerms.scannedViewBatches,
      ActivityPerms.multiTierMgrViewWhs
    ]) || AccessControl.hasPermission(permissions, [
      ActivityPerms.fwfInitialReviewer,
      ActivityPerms.digitalEntryAccessPortal
    ], true));
  }

  showBellPopup() {
    const { settings, permissions } = this.props;
    const modulesLicenced = settings && settings.showOngoingMonitoring;
    return modulesLicenced && (AccessControl.hasPermission(permissions, [ActivityPerms.monitoringExpertReviewer, ActivityPerms.monitoringResolver], false));
  }

  openAbout() {
    const { dispatch } = this.props;
    dispatch(openAboutModal());
  }

  renderBlankTitle() {
    const { location: { pathname } } = this.props;
    const path = pathname.split('/');
    if (
      path.length === 4 || (path.length === 5 && path.indexOf('pdf') !== -1)
    ) {
      return blanks[path[2]];
    }
    return null;
  }

  render() {
    const {
      location,
      username,
      settings,
      permissions,
      isPasswordChangeModalShown,
      cicAlertsAssignedCount,
      cicAlertsUnassignedCount,
      isAboutOpen
    } = this.props;
    const { moduleMenuShown, bellPopupShown, includeUnassigned } = this.state;
    const path = location.pathname;

    return (
      <nav className="navbar navbar-fixed">
        <section className="navbar-section">
          <NavLink to="/" exact activeClassName="active" className="btn btn-link btn-home" tabIndex={ 0 }>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M21 13v10h-6v-6h-6v6h-6v-10h-3l12-12 12 12h-3zm-1-5.907v-5.093h-3v2.093l3 3z" /></svg>
          </NavLink>
          { (AccessControl.hasPermission(permissions, [ActivityPerms.scannedValidate, ActivityPerms.electronicValidate]))
            ? <NavLink to="/validation-results" exact activeClassName="active" className="btn btn-link">
              Validation Results
            </NavLink> : null }
          { AccessControl.hasPermission(permissions, [ActivityPerms.miView])
            ? <NavLink to="/mi-dashboard" exact activeClassName="active" className="btn btn-link">
              MI
            </NavLink> : null }
          { this.showModuleMenu() && <div ref={ (node) => { this.moduleMenu = node; } } className="module-menu">
            <button onClick={ () => this.toggleMenu() } className={ `module-menu-link btn btn-link ${ moduleMenuShown ? 'active' : '' }` } type="button">
              Advanced
              <span className="icon icon-caret" />
            </button>
            <ul className={ moduleMenuShown ? 'show' : 'hide' }>
              { settings && settings.showOngoingMonitoring && AccessControl.hasPermission(permissions, [ActivityPerms.monitoringViewUnassigned, ActivityPerms.monitoringViewUnresolved,
                ActivityPerms.monitoringViewResolved, ActivityPerms.monitoringResolver, ActivityPerms.monitoringExpertReviewer])
                ? <li>
                  <NavLink to="/monitoring" exact activeClassName="active" className="btn btn-link" onClick={ () => this.toggleMenu() }>
                    Monitoring
                  </NavLink>
                </li> : null }
              { settings && settings.showAdvancedSearch && AccessControl.hasPermission(permissions, [ActivityPerms.scannedAdvancedSearch])
                ? <li>
                  <NavLink to="/advanced-search" className="btn btn-link" onClick={ () => this.toggleMenu() }>
                    Advanced Search
                  </NavLink>
                </li> : null }
              { settings && settings.showBatches && AccessControl.hasPermission(permissions, [ActivityPerms.scannedViewBatches])
                ? <li>
                  <NavLink to="/batches" exact activeClassName="active" className="btn btn-link" onClick={ () => this.toggleMenu() }>
                    Batches
                  </NavLink>
                </li> : null }
              { settings && settings.showDigitalEntry && AccessControl.hasPermission(permissions, [ActivityPerms.digitalEntryAccessPortal, ActivityPerms.fwfInitialReviewer], true)
                ? <li>
                  <NavLink to="/digital-entry" className="btn btn-link" onClick={ () => this.toggleMenu() }>
                    Digital Entry
                  </NavLink>
                </li> : null }
              { settings && settings.showMultiTierManager && AccessControl.hasPermission(permissions, [ActivityPerms.multiTierMgrViewWhs, ActivityPerms.multiTierMgrEditWhs])
                ? <li>
                  <NavLink to="/whs-management" className="btn btn-link" onClick={ () => this.toggleMenu() } id="navitem-whs-management">
                    Withholding Statements
                  </NavLink>
                </li> : null }
            </ul>
          </div> }
        </section>
        <section className="logo-container">
          <Link to="/">
            <div className="header-logo" />
          </Link>
          <PoweredBy />
        </section>
        <section className="navbar-section navbar-auth-section">
          { path.indexOf('/forms/') === 0 && <NavLink
            to={ path }
            exact
            activeClassName="active"
            className="btn btn-link"
          >
            { this.renderBlankTitle() } Form
          </NavLink> }
          { path.search(/batch\/\d*\/forms/gm) >= 0 && <NavLink
            to={ path }
            exact
            activeClassName="active"
            className="btn btn-link"
          >
            Batch Forms
          </NavLink> }
          { settings != null && settings.selectedClient != null && settings.selectedClient.value != null && settings.isMultiTenant === true
            && <span className="client-header-value text-ellipsis" title={ settings.selectedClient.value }>Client : { settings.selectedClient.value }</span> }
          { this.showBellPopup()
          && <button type="button" className="btn btn-link btn-monitoring">
            <span role="button" className="popup" aria-hidden="true" title={ !bellPopupShown ? 'Ongoing Monitoring Alerts' : '' }>
              <svg xmlns="http://www.w3.org/2000/svg" className={ this.getBellClassName() } onClick={ () => this.toggleBellPopup() } width="24" height="24" viewBox="0 0 16 16"><path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zm.995-14.901a1 1 0 1 0-1.99 0A5.002 5.002 0 0 0 3 6c0 1.098-.5 6-2 7h14c-1.5-1-2-5.902-2-7 0-2.42-1.72-4.44-4.005-4.901z" /></svg>

              <span ref={ (node) => { this.bellpopup = node; } } className={ bellPopupShown ? 'popuptext show' : 'popuptext hide' } id="alertpopup">
                <p><span className="numbers">{ cicAlertsAssignedCount }&nbsp;</span>Alerts for your review </p>
                <p className={ includeUnassigned ? 'showkeepspace' : 'hidekeepspace' }><span className="numbers">{ cicAlertsUnassignedCount }&nbsp;</span>Unassigned Alerts </p>
                <NavLink to="/monitoring" className="link" onClick={ () => this.toggleBellPopup() }>
                  Go to Ongoing Monitoring Dashboard
                </NavLink>
                <br />
                <span className="right">
                  <input
                    type="checkbox"
                    id="include-unassigned"
                    name="include-unassigned"
                    value="true"
                    defaultChecked="true"
                    onChange={ e => this.setIncludeAssigned(e.target.checked) }
                  />
                  <label htmlFor="include-unassigned">Include unassigned alerts</label>
                </span>
              </span>
            </span>
          </button> }
          <button type="button" className="icon icon-about icon-3x" title="About" onClick={ () => this.openAbout() } />
          <figure className="avatar avatar-sm">
            <span role="button" tabIndex={ 0 } onClick={ () => this.openPasswordChangeModal() } aria-hidden="true"><img src="/assets/images/avatar-large.png" alt={ this.changePasswordText } title={ this.changePasswordText } /></span>
          </figure>
          <div className="auth">
            <span className="username">{ username }</span>
            <button
              type="button"
              className="btn btn-link btn-logout"
              onClick={ () => this.logout() }
            >
              Logout
            </button>
          </div>
        </section>
        <section className="mobile-menu-dropdown dropdown dropdown-right">
          <button type="button" className="btn btn-lg btn-link dropdown-toggle">
            <span className="icon icon-more-vert" />
          </button>
          <ul className="menu">
            <li className="menu-item auth-menu-item">
              <figure className="avatar avatar-sm">
                <img src="/assets/images/avatar-large.png" alt="Avatar" />
              </figure>
              <div className="auth">
                <span className="username">{ username }</span>
                <button
                  type="button"
                  className="btn btn-link btn-logout"
                  onClick={ () => this.logout() }
                >
                  Logout
                </button>
              </div>
            </li>
            <li className="menu-item">
              <NavLink to="/" exact>
                HOME
              </NavLink>
            </li>
            { AccessControl.hasPermission(permissions, [ActivityPerms.scannedValidate, ActivityPerms.electronicValidate]) ? <li className="menu-item">
              <NavLink to="/validation-results">
                Validation Results
              </NavLink>
            </li> : null }
            { AccessControl.hasPermission(permissions, [ActivityPerms.miView]) ? <li className="menu-item">
              <NavLink to="/mi-dashboard">
                MI
              </NavLink>
            </li> : null }
            { settings && settings.showBatches && AccessControl.hasPermission(permissions, [ActivityPerms.scannedViewBatches]) ? <li className="menu-item">
              <NavLink to="/batches">
                Batches
              </NavLink>
            </li> : null }
            { settings && settings.showDigitalEntry && AccessControl.hasPermission(permissions, [ActivityPerms.digitalEntryAccessPortal, ActivityPerms.fwfInitialReviewer], true) ? <li className="menu-item">
              <NavLink to="/digital-entry">
                Digital Entry
              </NavLink>
            </li> : null }
            {
              // eslint-disable-next-line jsx-a11y/anchor-is-valid
              <li className="menu-item"><a href="#" onClick={ () => this.openAbout() }>About</a></li>
            }
          </ul>
        </section>
        <PasswordChangeModal
          isShown={ isPasswordChangeModalShown }
          onConfirmUpdate={ updateData => this.processPasswordChangeModal(updateData) }
          onCancel={ () => this.closePasswordChangeModal() }
        />
        { isAboutOpen && <AboutModal /> }
      </nav>
    );
  }
}

function mapStateToProps(state) {
  const {
    auth: {
      isPasswordChangeModalShown,
      sessionAuthMode
    },
    common: {
      isAboutOpen
    },
    monitoring: {
      cicAlertsUnassignedCount,
      cicAlertsAssignedCount
    }
  } = state;

  return {
    isPasswordChangeModalShown,
    isAboutOpen,
    sessionAuthMode,
    cicAlertsUnassignedCount,
    cicAlertsAssignedCount
  };
}

export default withRouter(connect(
  mapStateToProps
)(withContainerErrorBoundary(Header, 'Header')));
